<template>
  <section class="stages-experts">
    <rwl-heading h="3" align="center" class="stages-experts__title" v-html="$t('webinars.stages_experts_title')">

    </rwl-heading>

    <p class="stages-experts__description" v-html="$t('webinars.stages_experts_description')"></p>

    <ul class="stages-experts__list" v-html="$t('webinars.stages_experts_list')"></ul>

    <div class="stages-experts__avatars">
      <stages-experts-avatar @click="$modal.show('expert-1')" :index="0" class="expert-avatar">Przemysław Tkaczyk</stages-experts-avatar>
      <stages-experts-avatar @click="$modal.show('expert-2')" :index="1" class="expert-avatar">Marcin Śrutwa</stages-experts-avatar>
      <stages-experts-avatar @click="$modal.show('expert-3')" :index="2" class="expert-avatar">Karol Szczuka</stages-experts-avatar>
      <stages-experts-avatar @click="$modal.show('expert-4')" :index="3" class="expert-avatar">Marcin Gorzała</stages-experts-avatar>
    </div>
  </section>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "StagesExperts",
    components: { RwlHeading },
  }
</script>

<style lang="scss">
  @import "stages-tabs";
  ul.stages-experts__list {
  @include make-stages-features-list($color-rwl-green-100, 2)
  }
</style>
<style lang="scss" scoped>
  @import "stages-tabs";

  .stages-experts {
    padding: $stages-tabs-content-padding;
    font-size: $stages-tabs-content-font-size;
    line-height: $stages-tabs-content-line-height;

    .stages-experts__title.rwl-heading {
      margin-bottom: $spacing-5;
    }

    @media (min-width: $breakpoint-md-min) {
      padding: $stages-tabs-content-md-padding;
    }

    .stages-experts__avatars {
      margin-top: $spacing-5;
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      flex-direction: column;

      &::before {
        content: "";
        width: 100%;
        height: 1px;
        margin: $spacing-6 0;
        background-color: $color-rwl-gray-15;
      }

      .expert-avatar {
        margin-bottom: $spacing-5;
      }

      @media (min-width: $breakpoint-sm-min) {
        flex-direction: row;
        justify-content: space-between;
      }

      @media (min-width: $breakpoint-md-min) {
      }

      @media (min-width: $breakpoint-lg-min) {
        justify-content: space-around;
        .expert-avatar {
          width: 25%;
        }
      }
    }
  }
</style>
